import _extends from "@babel/runtime/helpers/extends";
import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import { Groups, LockLocked, WixForum } from '@wix/wix-ui-icons-common/lazy';
import clsx from 'clsx';
import { HeaderWrapper } from '../HeaderWrapper';
import s from './AnonymousResultsHeader.scss';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useResultsPageContextSafe } from '../../../Pages/ResultsLayout/ResultsPageContext';
import { useIsWixHpReferral } from '../../../hooks/useIsWixHpReferral';
const TrustBuilderItem = _ref => {
  let {
    icon,
    text
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    verticalAlign: "middle"
  }, icon, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal"
  }, text));
};
export const AnonymousResultsHeader = _ref2 => {
  var _useResultsPageContex;
  let {
    onBackClick,
    isResultsPageOptimizations,
    ...props
  } = _ref2;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const headerKey = 'domains_search_gate.storefront_results.optimized.page_title';
  const TrustBuilders = [{
    icon: /*#__PURE__*/React.createElement(Groups, {
      size: "18px"
    }),
    translationKey: 'domains_search_gate.storefront_results.optimized.trust_builder.millions'
  }, {
    icon: /*#__PURE__*/React.createElement(LockLocked, {
      size: "18px"
    }),
    translationKey: 'domain_search_gate.storefront_results.trust_builder.ssl'
  }, {
    icon: /*#__PURE__*/React.createElement(WixForum, {
      size: "18px"
    }),
    translationKey: 'domains_search_gate.storefront_results.optimized.trust_builder.support'
  }];
  const isMobile = useIsMobile();
  const query = (_useResultsPageContex = useResultsPageContextSafe()) == null ? void 0 : _useResultsPageContex.query;
  const isWixHpReferral = useIsWixHpReferral();
  const title = /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.resultsHeaderTitle
  }, t(headerKey));
  if (isMobile) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      align: "center",
      textAlign: "center",
      width: "100%",
      className: clsx(isWixHpReferral && s.mobileHeadingGap, isWixHpReferral && !query && s.mobileEmptyQueryGap)
    }, props), title);
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    gap: "SP3",
    marginBottom: "SP1"
  }, /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
    onBackClick: onBackClick
  }, props), title), !isResultsPageOptimizations && /*#__PURE__*/React.createElement(Box, {
    gap: "SP6",
    align: "center",
    verticalAlign: "middle",
    className: s.whyWixBenefits
  }, TrustBuilders.map(_ref3 => {
    let {
      icon,
      translationKey
    } = _ref3;
    return /*#__PURE__*/React.createElement(TrustBuilderItem, {
      key: translationKey,
      icon: icon,
      text: t(translationKey)
    });
  })));
};
//# sourceMappingURL=AnonymousResultsHeader.js.map